export enum StatsFields {
    NUMBER_OF_STUDENTS = 'numberOfStudents',
    UNPROFITABLE_COURSES = 'unprofitableCourses',
    TEACHERS_WITHOUT_COURSES = 'teachersWithoutCourses',
    INSTITUTIONS_WITHOUT_COURSES = 'institutionsWithoutCourses',
    INCOME = 'income',
    EMPLOYEE_ACQUISITION_STATS = 'employeeAcquisitionStats',
    SIGNUPS_PER_INSTITUTION = 'signupsPerInstitution',
    NUMBER_OF_STUDENTS_BY_PRODUCT_CATEGORY = 'numberOfStudentsByProductCategory',
    NUMBER_OF_ACTIVE_INSTITUTIONS = 'numberOfActiveInstitutions',
    TERMINATIONS_BY_PRODUCT_CATEGORY = 'terminationsByProductCategory',
    STUDENT_RETENTION = 'studentRetention',
    TEACHER_CHURN = 'teacherChurn',
    STUDENT_TIMELINE = 'studentTimeline',
    TEACHER_EXCESS = 'teacherExcess',
}
